import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ReactPaginate from "react-paginate";
import { PGET, POST } from "../../../api/adminApi";
import { CustomSvg } from "../../../utils/CustomSvg";
import { getDateTime } from "../../../utils/Dates";
import { Play, Pause } from "react-feather";
import { toast } from "react-toastify";

export default function SmsBulk() {
  const [items, setItems] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);

  const getItems = React.useCallback(async () => {
    const data = await PGET("/services/admin/api/bulk-sms", true, {
      page: currentPage,
      size: 10,
    });
    if (data && data.headers) {
      setPageCount(Math.ceil(data.headers["x-total-count"] / 10));
      setItems(data.data);
    }
  }, [currentPage]);

  const paginate = (data) => {
    setCurrentPage(data.selected);
  };

  async function sendItem(id) {
    const response = await POST(`/services/admin/api/bulk-sms/${id}/send`);
    if (response && response.success) {
      toast.success("Рассылка запущена");
      getItems();
    } else {
      toast.error(response?.response?.data?.message || "Ошибка при отправке");
    }
  }

  useEffect(() => {
    getItems();
  }, [getItems]);

  return (
    <div
      className="br-5 card"
      style={{ background: "#eef1ff", marginTop: "-0.9rem", height: "100vh" }}
    >
      <div className="card-header border-0 pt-5">
        <h3 className="card-title align-items-center flex-column w-100">
          <span className="card-label fw-bold fs-3 mb-1">CMC Рассылки</span>
        </h3>
        <div
          className="card-toolbar"
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          data-bs-trigger="hover"
          title="Click to add"
        >
          <Link
            to="/admin/sms-bulk-create"
            className="btn btn-sm btn-light-primary"
          >
            <CustomSvg
              path="/icons/duotune/arrows/arr075.svg"
              className="svg-icon-3"
            />
            Добавить новый
          </Link>
        </div>
      </div>
      <div className="px-3 pb-4 pt-2">
        <div style={{ overflow: "auto", maxHeight: "75vh" }}>
          <table className="table bg-white table-rounded p-0 border gy-4 gs-7">
            <thead className="position-sticky top-0 rounded">
              <tr className="fw-bold fs-6 text-gray-800 border-bottom-2 border-gray-200">
                <th
                  style={{
                    width: "30px",
                    backgroundColor: "#E7372C",
                    fontWeight: "700",
                    borderTopLeftRadius: "8px",
                  }}
                  className="text-white text-center"
                >
                  №
                </th>
                <th
                  className="text-start text-white"
                  style={{ backgroundColor: "#E7372C", fontWeight: "700" }}
                >
                  Кому
                </th>
                <th
                  className="text-start text-white"
                  style={{ backgroundColor: "#E7372C", fontWeight: "700" }}
                >
                  Сообщения
                </th>
                <th
                  className="text-start text-white"
                  style={{ backgroundColor: "#E7372C", fontWeight: "700" }}
                >
                  Время создания
                </th>
                <th
                  className="text-center text-white"
                  style={{ backgroundColor: "#E7372C", fontWeight: "700" }}
                >
                  Статус
                </th>
                <th
                  className="text-start text-white"
                  style={{
                    backgroundColor: "#E7372C",
                    fontWeight: "700",
                    borderTopRightRadius: "8px",
                  }}
                ></th>
              </tr>
            </thead>
            <tbody style={{ overflowX: "auto" }}>
              {items &&
                items.map((item, index) => {
                  return (
                    <tr key={item.id} className="borderBottom">
                      <td className="text-center">
                        {currentPage === 0
                          ? index + 1
                          : currentPage * 10 + index + 1}
                      </td>
                      <td className="text-start">
                        {Array.isArray(item.phones) && item.phones.length > 0
                          ? item.phones.join(", ")
                          : item.phones
                            ? item.phones
                            : item.sendTo === 1
                              ? "Всем"
                              : item.sendToDescription || item.sendTo}
                      </td>
                      <td className="text-start">
                        {item.message || item.messageText}
                      </td>
                      <td className="text-start">
                        {getDateTime(item.createdTime)}
                      </td>
                      <td className="text-start w-10">
                        <b
                          style={{
                            whiteSpace: "nowrap",
                          }}
                          className={`p-2 badge rounded font-weight-500 d-block ${
                            item.status === "NEW" ||
                            item.status === 0 ||
                            item.status === "0"
                              ? "badge-warning"
                              : item.status === "SENT" ||
                                  item.status === 2 ||
                                  item.status === "2"
                                ? "badge-success"
                                : "badge-danger"
                          }`}
                        >
                          {item.status === "NEW" ||
                          item.status === 0 ||
                          item.status === "0"
                            ? "Новый"
                            : item.status === "SENT" ||
                                item.status === 2 ||
                                item.status === "2"
                              ? "Отправлен"
                              : item.status}
                        </b>
                      </td>
                      <td className="text-end">
                        <div className="d-flex">
                          {item.status === 2 || item.status === "2" ? null : (
                            <button
                              onClick={() => sendItem(item.id)}
                              className="btn btn-icon shadow-sm btn-active-color-primary btn-sm"
                              title={
                                item.status === 1 || item.status === "1"
                                  ? "Pause"
                                  : "Start"
                              }
                            >
                              {item.status === 1 || item.status === "1" ? (
                                <Pause className="svg-icon-3" />
                              ) : (
                                <Play className="svg-icon-3" />
                              )}
                            </button>
                          )}
                        </div>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
        {pageCount > 1 && (
          <ReactPaginate
            forcePage={currentPage}
            breakLabel={"..."}
            breakClassName={"break-me"}
            pageCount={pageCount}
            marginPagesDisplayed={1}
            pageRangeDisplayed={1}
            onPageChange={paginate}
            containerClassName={"pagination"}
            activeClassName={"bg-dark text-white"}
            pageClassName={"page-item box-shadow br-5"}
          />
        )}
      </div>
    </div>
  );
}
